<script lang="ts">
    import * as yup from 'yup';
    import {Form, Message, isInvalid} from 'svelte-yup';
    import ValidationMessage from './controls/ValidationMessage.svelte';
    import Button from './controls/Button.svelte';  
    import Results from './Results.svelte'
    import { GetQuote, FormatResult, GetEliResult, SetInputs } from '../services/ApplicationDataServices';
    import { QuoteResult } from '../models/QuoteResult';
    import { Inputs } from '../models/Inputs';
    import { QuoteRequest } from '../models/QuoteRequest';
    import { EliBaseUrl} from '../services/Store';
    import { get } from 'svelte/store';

    import * as bootstrap from 'bootstrap'
    import { onMount } from 'svelte';

    
    onMount(async () => {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            console.log('el', tooltipTriggerEl);
            let tooltip = new bootstrap.Tooltip(tooltipTriggerEl);
            console.log(tooltip);
            return tooltip;
         });
	});
    

    let schema = yup.object().shape({
        clientName: yup.string().required("Client’s full name is required").test("len", "Client Name should be at least 5 characters and less than 40 characters.", val => val.length >= 5 && val.length <= 40),
        state: yup.string().required("State is required."),
        purchaseAge: yup.number().typeError('Purchase age must be between 50-85').required("Purchase age must be between 50-85").min(50, "Purchase age must be between 50-85").max(85, "Purchase age must be between 50-85"),
        gender: yup.string().required("Gender is required.").oneOf(["female", "male"],"Please select a gender."),
        calculatedBy: yup.string().required("Please select calculated by.").oneOf(["single", "guaranteed"],"Please select calculated by."),
        investmentAmountString: yup.string().typeError('Investment amount must be between $25,000  - $1,000,000').required("Investment amount must be between $25,000  - $1,000,000"),
        investmentAmount: yup.number().typeError('Investment amount must be between $25,000  - $1,000,000').min(25000, "Investment amount must be between $25,000  - $1,000,000").max(1000000, "Investment amount must be between $25,000  - $1,000,000")
    });

    let fields = {clientName:"", state: "", purchaseAge: null, gender:"", calculatedBy:"", investmentAmountString:"", investmentAmount: null};

    let submitted:boolean = false;
    let isValid:boolean = false;
    let baseurl:String = get(EliBaseUrl);
    let buttontext = "Calculate";
    let pressed:boolean = false;
    let result:QuoteResult = new QuoteResult();
    let inputs:Inputs = new Inputs();     

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });

    async function handleSubmit(event){
        event.preventDefault();
        submitted = true;     
        inputs = SetInputs(inputs, fields);       
            
        isValid = schema.isValidSync(fields);              
        document.getElementById('clientName').blur();       
        document.getElementById('purchaseAge').blur();
        document.getElementById('investmentAmount').blur();      
        if(!isValid) return;

        let solveType:string="";
        if (fields.calculatedBy == "single")
            solveType = "FaceAmount";
        else
            solveType = "Premium";
       inputs.investmentAmount = formatter.format(parseInt(fields.investmentAmount));  
       let today =  new Date();
       let eliQuoteRequest:QuoteRequest = new QuoteRequest("47253447-fc19-466d-bbdd-8d3d3243f12a","LibertySPWL 001", 0, "AgeSpecified", today,
            solveType, fields.state, fields.purchaseAge, fields.gender, fields.investmentAmount, fields.investmentAmount);
       let response = await GetQuote(baseurl, eliQuoteRequest);
       result = GetEliResult(response);
       result = FormatResult(result);
       
       buttontext="Recalculate";
       pressed = true;
       setTimeout(scrollDown,250);
    }
    function scrollDown(){
        document.getElementById('results').scrollIntoView();
    }
</script>
<div class="container page col-12">
    <div class="container content">
        <h1 class="cta">Calculate a client's financial legacy</h1>
        <p class="description">Use our interactive calculator to see how Protective Series Estate Maximizer can turn your client’s single payment into a stronger legacy. When they’re ready to apply, all it takes is a 10 minute underwriting process with our Ten Minute Legacy solution.</p>
        <div class="container form col-md-12">
            <p class="required-instructions">*Required Fields</p>
            <Form {schema} {fields} submitHandler={handleSubmit} {submitted}>
                <div class="spacer">
                    <ValidationMessage schema={schema} fields = {fields} fieldname = {"clientName"} inputType="textbox" placeholder="" labelName="Client's full name*" dataText=""  /> 
                </div>                                              
                <div class="form-group spacer">
                    <div>
                        <label for="state" class="label">State*</label>
                    </div>
                    <div id="select-wrap">
                        <div class="arrow">
                            <select id="state" class="form-select" bind:value={fields.state} >                             
                                <option value="Alabama">Alabama</option>
                                <option value="Alaska">Alaska</option>
                                <option value="Arizona">Arizona</option>
                                <option value="Arkansas">Arkansas</option>
                                <option value="California">California</option>
                                <option value="Colorado">Colorado</option>
                                <option value="Connecticut">Connecticut</option>
                                <option value="Delaware">Delaware</option>
                                <option value="District of Columbia">District of Columbia</option>
                                <option value="Florida">Florida</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Hawaii">Hawaii</option>
                                <option value="Idaho">Idaho</option>
                                <option value="Illinois">Illinois</option>
                                <option value="Indiana">Indiana</option>
                                <option value="Iowa">Iowa</option>
                                <option value="Kansas">Kansas</option>
                                <option value="Kentucky">Kentucky</option>
                                <option value="Louisiana">Louisiana</option>
                                <option value="Maine">Maine</option>
                                <option value="Maryland">Maryland</option>
                                <option value="Massachusetts">Massachusetts</option>
                                <option value="Michigan">Michigan</option>
                                <option value="Minnesota">Minnesota</option>
                                <option value="Mississippi">Mississippi</option>
                                <option value="Missouri">Missouri</option>
                                <option value="Montana">Montana</option>
                                <option value="Nebraska">Nebraska</option>
                                <option value="Nevada">Nevada</option>
                                <option value="New Hampshire">New Hampshire</option>
                                <option value="New Jersey">New Jersey</option>
                                <option value="New Mexico">New Mexico</option>
                                <option value="New York">New York</option>
                                <option value="North Carolina">North Carolina</option>
                                <option value="North Dakota">North Dakota</option>
                                <option value="Ohio">Ohio</option>
                                <option value="Oklahoma">Oklahoma</option>
                                <option value="Oregon">Oregon</option>
                                <option value="Pennsylvania">Pennsylvania</option>
                                <option value="Rhode Island">Rhode Island</option>
                                <option value="South Carolina">South Carolina</option>
                                <option value="South Dakota">South Dakota</option>
                                <option value="Tennessee">Tennessee</option>
                                <option value="Texas">Texas</option>
                                <option value="Utah">Utah</option>
                                <option value="Vermont">Vermont</option>
                                <option value="Virginia">Virginia</option>
                                <option value="Washington">Washington</option>
                                <option value="West Virginia">West Virginia</option>
                                <option value="Wisconsin">Wisconsin</option>
                                <option value="Wyoming">Wyoming</option>       
                            </select>    
                        </div>
                    </div> 
                    <Message name="state" />
                </div>
                <div class="spacer">
                    <ValidationMessage schema={schema} fields = {fields} fieldname = {"purchaseAge"} inputType="textbox" placeholder="" labelName="Purchase age*" dataText=""  />  
                </div>                                              
                <div class="form-group spacer">
                    <label for="gender" class="label">Gender*</label>
                    <div>
                        <input type="radio" bind:group={fields.gender} id="female" name="gender" value="female"><label for="female" class="radioLabel">Female </label>
                        <input type="radio" bind:group={fields.gender} id="male" name="gender" value="male"><label for="male"  class="radioLabel">Male</label>
                    </div>
                    <Message name="gender" />
                </div>                
                <div class="form-group spacer">
                    <label for="calculatedBy" class="label">Calculated by* <span data-bs-toggle="tooltip" data-bs-html="true" title="Calculated by: <br /><br />Single Payment - enter in the single payment amount to see the guaranteed death benefit it will generate. <br /><br />Guaranteed Death Benefit - enter in the death benefit amount you are looking for in order to find out the single payment necessary to achieve it"><span class="info">info</span></span></label>                    
                    <div>
                        <input type="radio" bind:group={fields.calculatedBy} id="single" name="calculatedBy" value="single"><label for="single" class="radioLabel">Single payment</label>
                        <input type="radio" bind:group={fields.calculatedBy} id="guaranteed" name="calculatedBy" value="guaranteed"><label for="guaranteed" class="radioLabel">Guaranteed death benefit</label>
                    </div>
                    <Message name="calculatedBy" />
                </div>
                <div class="form-group spacer">
                    <ValidationMessage schema={schema} fields = {fields} fieldname = {"investmentAmount"} inputType="currency" placeholder="Investment amount must be between $25,000 - $1,000,000" labelName="Amount*" dataText=""  />                                
                </div>
                <Button bind:buttontext />
            </Form>
            <p class="disclosure"><span class="bold">Disclosure:</span>
                Disclosure: The information collected in this form by Protective will be used to offer you services that meet your needs and for other business purposes. Please visit our Privacy Policy for more information about our information practices, including information about your privacy choices.         </p>
        </div>
    </div>
    <div id="results"></div>
    {#if pressed}
        <Results result={result} inputs={inputs} />
    {/if}
</div>
<style lang="scss">
    :global(.tooltip-inner){
        background-color:#7D55C7 !important;
        color: #fff;
        text-align:left !important;
        font-family: 'Open Sans' !important;
        font-size: 14px !important;
        line-height: 18px;
        font-weight: 700;
        padding:20px !important;
        max-width: 400px !important;
        opacity: 100% !important;
    }
    :global(.tooltip .tooltip-arrow::before){
        border-top-color:#7D55C7 !important;     
    }
    h1.cta{
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 42px;
        line-height: 52px;
        text-align:  center;
        margin-bottom: 32px;
        @media(max-width:992px){
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 22px;
            line-height: 32px;
            text-align: left;
            margin-bottom: 16px;
            margin-left: 10px;
        }
    }
    p.description{
        text-align: center;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 32px;
        margin-bottom: 60px;      
        @media(max-width:992px){ 
            text-align: left;
            line-height: 24px;
            margin-bottom: 24px;
            margin-left: 10px;
        } 
    }
    p.required-instructions{
        margin-bottom: 24px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 26px;
    }
    select {
        max-width:100% !important;
        max-height: 48px;
        width:674px;
        height:48px;
        border: 1px solid #C6C6C6;
        border-radius: 100px;
        margin-top: 8px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;  
        background-color: #FFFFFF;    
        background-image: none;
        padding-left: 29px;
    }   
    select option {
        background-color: #C6C6C6;
        color: black;
    }   
    .arrow{
        position: relative;
        z-index: 2;
    }
    .arrow::after{
        content: "expand_more";
        font-family: "Material Icons Outlined";
        font-size: 24px;
        position: absolute;        
        right: 19px;
        top: 15px;
        color: #4C12A1;
        pointer-events: none;
    }  
    .radioLabel{
        font-family: Open Sans;
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        letter-spacing: 0px;
        text-align: left;
        color:#696969;
        margin-right: 45px;
        margin-left:12px;        
        position: inherit;
    }
    input[type="radio"]{
        accent-color: #4C12A1;
        height: 20px;
        width: 20px;
        border-radius: 0px;
        border: 2px solid #4C12A1 ;
        vertical-align: sub;
        margin-top:8px;
    }
    input[type="radio"]:checked + label{
        color:#000000;
    }
    .form input[type="radio"] + label:after{
     display: none;        
    }
    .form input[type="radio"] + label:before{
     display: none;        
    }    
    .spacer{
        margin-bottom: 24px;
    }
    .disclosure{
        font-family: 'Open Sans Condensed';
        font-size: 16px;
        line-height: 30px;
        font-weight: 300;
    }    
</style>